import getSkills from './getSkills';
import createSkill from './createSkill';
import updateSkill from './updateSkill';
import deleteSkill from './deleteSkill';

const actions = {
    getSkills,
    createSkill,
    updateSkill,
    deleteSkill,
};

export default actions;